export const ScrollChevron = {
  src: 'https://nest-platform-assets.porter.in/Chevron_2337928d79/Chevron_2337928d79.svg',
  alt: 'arrow',
} as const;
